// metronic_8 app — extends bootstrap5's app with Metronic/KT-specific
// behaviour. Bootstrap-conceptual logic (data-bs-theme handling) lives one
// tier up in core/themes/bootstrap5/scripts/app.js and is inherited
// here via Object.assign; only the KT-component init and KT page-loading
// spinner integration are metronic_8-specific.
const KTComponents = require("../vendor/keenthemes/src/js/components/_init");
const zb5App = require('../../../../core/themes/bootstrap5/scripts/app');

const app = Object.assign({}, zb5App, {
    // Override: chain to bootstrap5's initTheme (which runs initThemeMode
    // for the data-bs-theme attribute and bridgeTierAttrs(document) for the
    // Bootstrap auto-discovery markers) before staging the m8-specific KT
    // initialisation. The framework's app calls initTheme() once at the
    // start of init().
    initTheme: function () {
        // zb5App.initTheme.call(this) runs initThemeMode + bridgeTierAttrs(document)
        // — the bs bridging must precede KTComponents.init() because KT's
        // tooltip auto-init scans data-bs-toggle="tooltip" and we now emit
        // the zit-namespaced equivalent that needs mirroring first.
        zb5App.initTheme.call(this);
        // Stage the zit→kt menu attribute mirroring so KTMenu's auto-init
        // (called inside KTComponents.init() below as KTMenu.init()) finds
        // every menu in the page's static markup. Calling submenu.createInstances()
        // also runs an extra KTMenu.createInstances() — that's harmless
        // because KT widgets are idempotent (KTUtil.data reuse).
        this.hm.behaviors.submenu.createInstances();
        KTComponents.init();
    },

    // Override: show the KT page-loading spinner when the UI is blocked.
    uiBlock: function (reason) {
        if (this.uiBlockReasons.length === 0) {
            KTApp.showPageLoading();
        }

        this.uiBlockReasons.push(reason);
    },

    // Override: hide the KT page-loading spinner once all block reasons are cleared.
    uiUnblock: function (reason) {
        let index = this.uiBlockReasons.indexOf(reason);
        if (index !== -1) {
            this.uiBlockReasons.splice(index, 1);
        }

        if (this.uiBlockReasons.length === 0) {
            KTApp.hidePageLoading();
        }
    }
});

module.exports = app;
